import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import SignUpScreenModal from "../../screens/Auth/CommonModal/SignUpScreenModal";
import LoginScreenModal from "../../screens/Auth/CommonModal/LoginScreenModal";
import {
  useNavigation,
  NavigationProp,
  StackActions,
  useNavigationState,
} from "@react-navigation/native";
import { AppScreens } from "../../screens/Utility/AppScreens";
import { isEventShareURL } from "../urlUtils";

interface AuthenticatedRoutesProps {
  children: React.ReactNode;
}

const AuthenticatedRoutes: React.FC<AuthenticatedRoutesProps> = ({
  children,
}) => {
  const { isLoggedIn, showModal, setShowModal, modalType } =
    useContext(AuthContext);
  const navigation = useNavigation<NavigationProp<any>>();
  function previousUrl() {
    const routes = useNavigationState((state) => state.routes);

    const previousRoute = routes[0];
    // previousRoute.state.routes[1].state.routes[0].path

    // const routes = navigation.getState()?.routes;
    // const prevRoute = routes[routes.length - 2];

    const prevUrls = previousRoute?.state?.routes[1]?.state?.routes[0]?.path;
    const prevUrl = previousRoute?.state?.routes[1]?.state?.routes[1]?.path;

    if (prevUrl) {
      return prevUrl;
    } else if (prevUrls) {
      return prevUrls;
    } else {
      window.location.href.replace(window.location.origin, "");
    }
  }
  const currentPath = previousUrl();

  useEffect(() => {
    if (!isLoggedIn) {
      // Check if current URL is an event share link
      if (isEventShareURL()) {
        // Extract the full URL path and encode it for Setup screen
        const fullPath = window.location.pathname + window.location.search;

        console.log(
          "🎮 AuthenticatedRoutes: GameShow URL detected, redirecting to Setup with path:",
          fullPath
        );

        // Navigate to Setup screen with encoded path parameter
        navigation.dispatch(
          StackActions.replace(AppScreens.SetupScreen, {
            path: fullPath,
          })
        );
      } else {
        console.log("🔒 AuthenticatedRoutes: Not logged in, redirecting to Setup with currentPath:", currentPath);
        navigation.dispatch(
          StackActions.replace(AppScreens.SetupScreen, {
            path: currentPath,
          })
        );
      }
    } else {
      console.log("✅ AuthenticatedRoutes: User is logged in, rendering children");
    }
  }, [isLoggedIn, navigation, currentPath]);
  return <>{children}</>;
  // return isLoggedIn ? children : null;
};

export default AuthenticatedRoutes;
